const Logo = () => {
    return <img src="https://uploads-ssl.webflow.com/64f729712e910c0fe97bc074/64f729712e910c0fe97bc08b_64cf6f5a47cca3362674a65d_image%2013-p-130x130q80.png"
    alt = "Lumos Labs" 
/>
}

export default Logo